import { FC, ReactElement } from 'react';

import { Skeleton } from '../../../../components';
import { generateIdArray } from '../../../../helpers/array';
import { randomInBetweenValue } from '../../../../helpers/number';

import './BlogPostCardListSkeletons.scss';

interface BlogPostCardListSkeletonsProps {
    numberOfSkeletons?: number;
    className?: string;
}

export const BlogPostCardListSkeletons: FC<BlogPostCardListSkeletonsProps> = ({
    numberOfSkeletons = randomInBetweenValue(4, 6),
    className = '',
}): ReactElement => {
    const blogCardSkeletons = generateIdArray(numberOfSkeletons);

    return (
        <ul className={`blog-post-card-list-skeletons ${className}`}>
            {blogCardSkeletons.map(skeleton => (
                <li key={skeleton} className="blog-post-card-list-skeletons__list-item">
                    <div className="blog-post-card-list-skeletons__image" />

                    <div className="blog-post-card-list-skeletons__meta-wrapper">
                        <Skeleton className="blog-post-card-list-skeletons__meta" />
                    </div>

                    <Skeleton className="blog-post-card-list-skeletons__title" />

                    <div className="blog-post-card-list-skeletons__button-wrapper">
                        <Skeleton className="blog-post-card-list-skeletons__button" />
                    </div>
                </li>
            ))}
        </ul>
    );
};
